import { Dispatch } from 'redux';
import {
  ConfigState,
  LOAD_CONFIG,
  SET_LOCALE,
  SET_ORGANIZATION_CODE,
  SET_PAGE_TITLE,
  SET_SELLING_CODE,
  SET_TRANSLATION_DATE_FORMAT
} from './types';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { ReduxStore } from '../payload-types';
import { CIAM_LOGIN_SUCCESS } from '../adfs';
import axios from 'axios';
import { AUTH_HEADERS, LOGIN_ROUTES } from '@trip-ux/constants';
import { GET_CLAIMS_FAILED, GET_CLAIMS_SUCCESS, SET_USER } from '../user-profile';
import { KEEP_ALIVE_SUCCESS } from '../idle';

// TODO: org code should not be CM as default, should be whatever the user's org is
const storage = createWebStorage('session');
const org = 'organizationCode';
const ts = 'translationSpace';

export const loadConfig =
  (payload: ConfigState) =>
  async (dispatch: Dispatch, getState: () => ReduxStore): Promise<void> => {
    const { loginPending, tokenPending } = getState().adfsAuth;

    if (!loginPending && !tokenPending) {
      try {
        const response = await axios.get(LOGIN_ROUTES.AUTH_GET_USER);
        const { user, claims, monerisProfileId, sessionExpiration } = response.data;
        dispatch({ type: SET_USER, payload: user });
        dispatch({ type: GET_CLAIMS_SUCCESS, payload: { claims: claims, user: user} });
        dispatch({ type: CIAM_LOGIN_SUCCESS });
        dispatch({ type: KEEP_ALIVE_SUCCESS, payload: sessionExpiration });
        const organizationCode = user.organizationCode;
        const translationSpace = payload.options.translationSpace;
        dispatch({
          type: LOAD_CONFIG,
          payload: {
            ...payload,
            options: { ...payload.options, organizationCode, translationSpace, monerisProfileId }
          }
        });
      } catch (error) {
        dispatch({ type: GET_CLAIMS_FAILED, payload: error });
        window.location.href = '/';
      }
    }
  };

export const setOrganizationCode =
  (orgCode: string, transSpace: string) =>
  async (dispatch: Dispatch, getState: () => ReduxStore): Promise<boolean> => {
    try {
      const UserProfile = getState().userProfile;
      if (UserProfile.userType === AUTH_HEADERS.CIAM_ID) {
        await axios.get(LOGIN_ROUTES.AUTH_SET_CIAM_USER, { headers: { newOrg: orgCode } });
      } else if (UserProfile.userType === AUTH_HEADERS.LAN_ID) {
        await axios.get(LOGIN_ROUTES.AUTH_SET_USER, { headers: { newOrg: orgCode } });
      }

      storage.setItem(org, orgCode);
      storage.setItem(ts, transSpace);
      dispatch({
        type: SET_ORGANIZATION_CODE,
        payload: {
          organizationCode: orgCode,
          translationSpace: transSpace
        }
      });
      return true;
    } catch (error) {
      dispatch({ type: GET_CLAIMS_FAILED, payload: error });
      return false;
    }
  };

  export const setSellingCode =
  (sellingCode: string, transSpace: string) =>
  async (dispatch: Dispatch, getState: () => ReduxStore): Promise<void> => {
    try {
      const UserProfile = getState().userProfile;
      if (UserProfile.userType === AUTH_HEADERS.CIAM_ID) {
        await axios.get(`${LOGIN_ROUTES.AUTH_SET_CIAM_USER}`, { headers: {sellingCode } });
      }

      storage.setItem(sellingCode, sellingCode);
      storage.setItem(ts, transSpace);
      dispatch({
        type: SET_SELLING_CODE,
        payload: {
          sellingCode,
          translationSpace: transSpace
        }
      });
    } catch (error) {
      dispatch({ type: GET_CLAIMS_FAILED, payload: error });
    }
  };

export const setPageTitle =
  (pageTitle: string) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_PAGE_TITLE,
      payload: {
        pageTitle
      }
    });
  };

export const setTranslationDateFormat =
  (currentDateFormat: string) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_TRANSLATION_DATE_FORMAT,
      payload: {
        currentDateFormat
      }
    });
  };

export const setLocale =
  (locale: string) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_LOCALE,
      payload: {
        locale
      }
    });
  };
